// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"89fdaeae","171":"3dffc42e","374":"a91bb9cf","456":"7399710a","507":"df12595d","801":"6e5e7544","857":"d4b28f30","990":"0c17e56c","995":"1c20489b"}[chunkId] + ".chunk.js";
};